import { Field, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import { requestDemo } from "../../services/ApiService";
import LabelWithTick from "../RequestModal/Adwords/helper";
import FormError from "../RequestModal/FormError";
import greenTick from "../../assets/images/modal/tick.svg";
import "./styles.scss";
import "react-phone-number-input/style.css";
import Phone, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-input-2/lib/style.css";

const autoSubmit = ({ values, resetForm, handleSubmit, openedFromButton }) => {
  if (
    values.quantity &&
    isValidPhoneNumber(values.contact) &&
    (!openedFromButton || values.fabricCategory)
  ) {
    handleSubmit({
      values: {
        quantity: values.quantity,
        contact: values.contact,
        fabricCategory: values.fabricCategory,
      },
      resetForm,
    });
  }
};

const LeadsSubmissionForm = ({
  closedText,
  submitText,
  _handleClose,
  setSubmitSuccess,
  isSubmitSuccessful,
  fillDetails,
  showDropdown = false,
  requirementFormClass = {},
  footerClass = {},
  formRef,
  formType = "others",
  fabricType,
  openedFromButton = false,
}) => {
  const { search } = useLocation();
  const REQUIRED_QUANTITY_FOR_FORM = [
    "5,000 m",
    "10,000 m",
    "More than 10,000 m",
  ];
  const FABRIC_CATEGORY = ["Cotton", "Rayon", "Polyester", "Denim"];
  const FORM_INITIAL_STATE = {
    contact: "",
    quantity: "",
    fabricCategory: "",
  };

  const ValidationSchema = ({ isValidPhoneNumber, openedFromButton }) =>
    Yup.object().shape({
      contact: Yup.string()
        .required("This field is required")
        .test((contactVal, context) => {
          let message = null;
          if (!isValidPhoneNumber(`${contactVal}`)) {
            message = "Enter a valid phone number";
          }
          return message
            ? context.createError({
                message: message,
              })
            : true;
        }),
      quantity: Yup.string(),
      fabricCategory: openedFromButton
        ? Yup.string().required("Please select a fabric category")
        : Yup.string(),
    });

  const formContentRef = useRef();
  const handleSubmit = ({ values, resetForm }) => {
    const { contact, quantity, fabricCategory } = values || {};
    let payload = {
      formType,
      fabricType: openedFromButton ? fabricCategory : fabricType,
    };
    payload["contact"] = `${contact}`;
    if (quantity) {
      payload["requiredQuantity"] = quantity;
    }
    requestDemo({
      ...payload,
    })
      .then(() => {
        setSubmitSuccess(true);
      })
      .catch((err) => {
        let msg =
          "Error occurred while submitting the request. Please try again.";
        if (typeof err === "string") {
          msg = `Following e${msg.substr(1)}\n${err}`;
        }

        alert(msg);
      })
      .finally(() => {
        resetForm();
      });
  };
  return (
    <Formik
      innerRef={formRef}
      initialValues={FORM_INITIAL_STATE}
      validationSchema={ValidationSchema({
        isValidPhoneNumber,
        openedFromButton,
      })}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({
        errors,
        touched,
        setFieldValue,
        values,
        setValues,
        handleChange,
        resetForm,
        dirty,
      }) => {
        // if (
        //   !Boolean(Object.keys(errors).length) &&
        //   values.contact &&
        //   values.quantity
        // ) {
        //   handleSubmit({ values, resetForm });
        // }
        return (
          <div className={requirementFormClass + " requirementContainer "}>
            <div className={"requirementForm"}>
              {!isSubmitSuccessful ? (
                <div className="formContent" ref={formContentRef}>
                  {openedFromButton && (
                    <div className="field">
                      <LabelWithTick
                        label="Select Fabric Category"
                        withValidation={true}
                        style={{ color: "#676773" }}
                        isValid={values?.fabricCategory !== ""}
                        labelClass={"label"}
                      />
                      <div
                        role="group"
                        className="checkbox-group"
                        aria-labelledby="fabric-category-group"
                      >
                        {FABRIC_CATEGORY.map((category) => (
                          <label key={category} className="radioButton">
                            <Field
                              type="radio"
                              name="fabricCategory"
                              value={category}
                              onClick={() => {
                                values.fabricCategory = category;
                                autoSubmit({
                                  values,
                                  resetForm,
                                  handleSubmit,
                                  openedFromButton,
                                });
                              }}
                            />
                            <span>{category}</span>
                          </label>
                        ))}
                      </div>
                      {errors.fabricCategory && touched.fabricCategory && (
                        <div className="error">{errors.fabricCategory}</div>
                      )}
                    </div>
                  )}
                  <div className="field">
                    <LabelWithTick
                      label="Quantity required"
                      withValidation={true}
                      style={{ color: " #676773" }}
                      isValid={values?.quantity != ""}
                      labelClass={"label"}
                    />
                    <div
                      role="group"
                      className="checkbox-group"
                      aria-labelledby="checkbox-group"
                    >
                      {REQUIRED_QUANTITY_FOR_FORM.map((quantity) => (
                        <label key={quantity} className="radioButton">
                          <Field
                            type="radio"
                            name="quantity"
                            value={quantity}
                            onClick={() => {
                              values.quantity = quantity;
                              autoSubmit({
                                values,
                                resetForm,
                                handleSubmit,
                                openedFromButton,
                              });
                            }}
                          />
                          <span>{quantity}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="field-contact field">
                    <label htmlFor="contact" className="labelWidth">
                      <LabelWithTick
                        label="Mobile number"
                        withValidation={true}
                        style={{ color: " #676773" }}
                        isValid={
                          values?.contact && isValidPhoneNumber(values?.contact)
                        }
                        labelClass={"label"}
                      />

                      <div className="field-contact">
                        <Phone
                          onChange={(value) => {
                            setFieldValue("contact", value);
                            values.contact = value;
                            autoSubmit({
                              values,
                              resetForm,
                              handleSubmit,
                              openedFromButton,
                            });
                          }}
                          value={values?.contact}
                          placeholder="Mobile number"
                          id="contact"
                          name="contact"
                          defaultCountry="IN"
                          type="tel"
                          international
                        />
                      </div>
                    </label>
                    {errors.contact ? (
                      <FormError
                        error={errors.contact}
                        errorClass="field-error"
                      />
                    ) : null}
                  </div>
                </div>
              ) : (
                <div className="successful_container">
                  <div>
                    <div className="tickImg">
                      <img src={greenTick} alt="icon" />
                    </div>

                    <p className="successTitle">Thank you for your interest!</p>
                    <p className="successSubTxt" style={{ marginBottom: 40 }}>
                      One of our fabric experts will reach you in 24 hours.
                    </p>
                    <p className="successSubTxt" style={{ marginBottom: 52 }}>
                      Think Fabric. Think Locofast.
                    </p>
                  </div>
                </div>
              )}
              {!isSubmitSuccessful ? (
                <div className={"flex-center submit__container " + footerClass}>
                  <button
                    className="cross"
                    type="button"
                    onClick={() => _handleClose()}
                  >
                    {closedText}
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary buttonWidth"
                    value="submit"
                    // onClick={() => handleSubmit({ values, resetForm })}
                    disabled={!dirty || !!Boolean(Object.keys(errors).length)}
                  >
                    {submitText}
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        );
      }}
    </Formik>
  );
};
export default LeadsSubmissionForm;
